import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthFacade } from '@piqet-angular/data';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { RedirectService } from '../../service/redirect.service';

@Injectable({
  providedIn: 'root',
})
export class AuthRedirectGuard implements CanActivate {
  token: any;

  constructor(
    private router: Router,
    public authFacade: AuthFacade,
    private cookieService: CookieService,
    private redirectService: RedirectService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.token = this.cookieService.get('token');
    const isFlag = this.cookieService.get('forceResetPasswordDisable');
    if (isFlag === 'false') {
      this.router.navigate(['/secure-password']);
    } else if (this.token) {
      // Check for stored redirect URL or return URL from query params
      const redirectUrl = this.redirectService.getRedirectUrl() || route.queryParams['returnUrl'];
      if (redirectUrl && redirectUrl !== '/login' && redirectUrl !== '/') {
        this.redirectService.clearRedirectUrl();
        this.router.navigateByUrl(redirectUrl);
      } else {
        this.router.navigate(['/dashboard']);
      }
      return false;
    }
    return true;
  }
}
